import React, { useState } from "react";
import Modal from "react-modal";
import { convertThenFormat } from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import { CheckCircleIcon, CrossCircleIcon } from "../../../images/icons/icons";

const DetailListings = ({ row }) => {
  const iniModValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  function onCloseModal() {
    setModValues(iniModValues);
  }

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.cardType === "description" ? "mod-width-50p" : ""
          }`}
        >
          <ModalHeadAndClose
            title={
              modValues.cardType === "description"
                ? "Remarks"
                : modValues.cardName?.replace(/_/g, " ")
            }
            onClose={onCloseModal}
          />

          {modValues.cardType === "description" ? (
            <div className="discussionModalMessage mt30">
              <p className="message">
                {modValues.description || "No Content Available"}
              </p>
            </div>
          ) : null}
        </div>
      </Modal>

      <div className="user-profile-container staff-onboarding-detail-modal">
        <div className="user-profile-details">
          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Gym Name</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.gym_name || "NA"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Approval Manager</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {row?.reporting_manager_name || "NA"}
                <br />
                <small style={{ textTransform: "lowercase" }}>
                  {row?.reporting_manager_mobile || ""}
                  <br />
                  {row?.reporting_manager_email || ""}
                </small>
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Approved/Rejected By</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {row?.aprv_rej_by_name || "NA"}
                <br />
                <small style={{ textTransform: "lowercase" }}>
                  {row?.aprv_rej_by_mobile || ""}
                  <br />
                  {row?.aprv_rej_by_email || ""}
                </small>
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Max Leave(Monthly)</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.no_ofdays || 0} Day(S)</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Apply Before</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.days_before || 0} Day(S)</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Paid Leave</p>
            </div>
            <div className="user-details-info">
              <p className="info-name icon">
                {" "}
                {row?.is_paid ? <CheckCircleIcon /> : <CrossCircleIcon />}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">approval required</p>
            </div>
            <div className="user-details-info">
              <p className="info-name icon">
                {" "}
                {row?.approval_required ? (
                  <CheckCircleIcon />
                ) : (
                  <CrossCircleIcon />
                )}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Remarks</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {row.description || "NA"}
                {/* {row.description?.length <= 15 ? (
                  row.description
                ) : row.description?.length >= 15 ? (
                  <>
                    {row.description?.substring(0, 15)}
                    <b
                      className="link"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        setModValues((prevs) => ({
                          ...prevs,
                          isModOpen: true,
                          cardType: "description",
                          description: row.description,
                        }))
                      }
                    >
                      ...Read More
                    </b>
                  </>
                ) : (
                  "NA"
                )} */}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Staff Salary(Monthly)</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                ₹{convertThenFormat(row?.salary || 0)}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Deducted Amount</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                ₹{convertThenFormat(row?.deducted_salary || 0)}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Taken/Total Leaves(Year)</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {row?.total_leave_days_used || 0}/{row?.yearly_leave || 0}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Remaining Leaves(Year)</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {row?.total_leave_days_remaining || 0}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">doc required</p>
            </div>
            <div className="user-details-info">
              <p className="info-name icon">
                {row?.doc_required ? <CheckCircleIcon /> : <CrossCircleIcon />}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">document</p>
            </div>
            <div className="user-details-info">
              <p className="info-name icon">
                <button
                  type="button"
                  className="actionBtn icon download"
                  disabled={!row?.required_doc}
                  style={{
                    cursor: row?.required_doc ? "pointer" : "not-allowed",
                  }}
                >
                  <a href={row?.required_doc}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-cloud-arrow-down"
                      viewBox="0 0 16 16"
                      style={{
                        color: row?.required_doc ? "#CD0909" : "gray",
                        width: "35px",
                        height: "35px",
                      }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                      />
                      <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                    </svg>
                  </a>
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailListings;
